import { memoize } from 'lodash';

export const forceDownload = memoize((href: string) => {
    const dialog = href.indexOf('?') === -1 ? '?forceDialog=1' : '&forceDialog=1';
    return href + dialog;
});
